import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent } from '../../../../../components/ui/card';
import { cn } from '../../../../../lib/utils';

function StatsCard({ title, value, icon: Icon, color, bgColor, isLoading }) {
  if (isLoading) {
    return (
      <Card style={{ border: '1px solid hsl(var(--border))' }}>
        <CardContent className="p-5">
          <div className="flex items-center justify-between">
            <div className="space-y-2">
              <div className="h-4 w-20 bg-muted animate-pulse rounded" />
              <div className="h-8 w-16 bg-muted animate-pulse rounded" />
            </div>
            <div className="h-12 w-12 bg-muted animate-pulse rounded-lg" />
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card style={{ border: '1px solid hsl(var(--border))' }}>
      <CardContent className="p-5">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-muted-foreground">{title}</p>
            <p className="text-2xl font-bold text-foreground mt-1">{value}</p>
          </div>
          {Icon && (
            <div className={cn('p-3 rounded-lg', bgColor)}>
              <Icon className={cn('h-6 w-6', color)} />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}

StatsCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  icon: PropTypes.elementType,
  color: PropTypes.string,
  bgColor: PropTypes.string,
  isLoading: PropTypes.bool,
};

StatsCard.defaultProps = {
  icon: null,
  color: 'text-primary',
  bgColor: 'bg-primary/10',
  isLoading: false,
};

export default StatsCard;
